// Dev Priority API (legacy Backlogs mock API removed)

import apiClient from '@/api/client';
import type {
  DevPriorityTicket,
  PriorityUpdateModel,
  SetPerceivedPriorityModel,
} from './types';

const DEV_PRIORITY_API_BASE = '/api/devPriority';

export const getDevPriorityTickets = async (): Promise<DevPriorityTicket[]> => {
  const response = await apiClient.get<DevPriorityTicket[]>(`${DEV_PRIORITY_API_BASE}/priorities`);
  return response.data;
};

export const updateTicketPriority = async (
  ticketId: number,
  priority: number
): Promise<void> => {
  const model: SetPerceivedPriorityModel = { ticketId, priority };
  await apiClient.post(`${DEV_PRIORITY_API_BASE}/setPerceivedPriority`, model);
};

export const reorderTicket = async (
  ticketId: number,
  newIndex: number
): Promise<DevPriorityTicket[]> => {
  const model: PriorityUpdateModel = { ticketId, newIndex };
  const response = await apiClient.post<DevPriorityTicket[]>(`${DEV_PRIORITY_API_BASE}/updatePriority`, model);
  return response.data;
};

export const getUserType = async (): Promise<string> => {
  const response = await apiClient.get(`${DEV_PRIORITY_API_BASE}/userType`, {
    responseType: 'text',
  });
  return response.data as string;
};
